module.exports = __webpack_public_path__ + "static/img/110719.b568150.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/events/110719.png
// module id = EhZE
// module chunks = 0